export const initialState = {
  picture: '',
  list: [],
  breed: '',
  score: 0,
  showFail: false,
  highScores: [],
  playerKey: '',
  name: ''
};
